import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { TabletButton } from '@campfire/tablet-button';
import { Field } from '@campfire/field';
import { Select } from '@campfire/select';
import { Form, Formik } from 'formik';
import { object as YupObject, string as YupString } from 'yup';
import { CreateTrialAccountFormValues, RegionType } from '../CreateTrialAccountTypes';
import {
  HEARD_FROM_OPTIONS,
  TRIAL_STEPS,
  TrialStepsEnum,
  VOLABY_REGION,
  VOLS_NO_OPTION,
} from '../CreateTrialAccountConsts';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { StepHeader } from './Stepheader';

const OrgDetailStepSchema = YupObject().shape({
  tenantName: YupString()
    .required('Please enter your organisation name')
    .max(100, 'Organisation name is too long'),
  vols: YupString().required('Please select the number of vols'),
  region: YupString().required('Please select the country'),
  hearAt: YupString().required('Please select one of the option'),
});

export const OrgDetailStep = ({
  trialData,
  next,
  prev,
}: {
  trialData: CreateTrialAccountFormValues;
  next: (newData: CreateTrialAccountFormValues, step: string) => void;
  prev: (newData: CreateTrialAccountFormValues, step: string) => void;
}) => {
  const {
    ORG_DETAIL: { step, title, subtitle },
  } = TRIAL_STEPS;
  const { theme, isMobile } = useCampfireTheme();

  const handleSubmit = (values: CreateTrialAccountFormValues) => {
    next(values, TrialStepsEnum.TERMS_OF_USE);
  };

  return (
    <Formik initialValues={trialData} validationSchema={OrgDetailStepSchema} onSubmit={handleSubmit}>
      {({ values }) => (
        <Form>
          <Box mx={isMobile ? '24px' : '34px'} my='28px'>
            <StepHeader step={step} title={title} subtitle={subtitle} />
            <Grid container spacing={3} style={{ marginTop: '16px' }}>
              <Grid item container sm={12} spacing={4}>
                <Grid item xs={12} sm={6}>
                  <Field shrink required fullWidth name='tenantName' label='Name' variant='outlined' />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Select
                    shrink
                    required
                    fullWidth
                    variant='outlined'
                    name='vols'
                    label='# Volunteers'
                    items={VOLS_NO_OPTION}
                    renderFunction={(item: string) => item}
                    valueFunction={(item: string) => item}
                    InputProps={{
                      style: { borderRadius: '8px', color: theme.color.grey.neutral300 },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container sm={12} spacing={4}>
                <Grid item xs={12} sm={6}>
                  <Select
                    shrink
                    required
                    fullWidth
                    variant='outlined'
                    name='region'
                    label='Country'
                    items={VOLABY_REGION}
                    renderFunction={(item: RegionType) => item.label}
                    valueFunction={(item: RegionType) => item.value}
                    InputProps={{
                      style: { borderRadius: '8px', color: theme.color.grey.neutral300 },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Select
                    shrink
                    fullWidth
                    variant='outlined'
                    name='hearAt'
                    label='How did you hear about Volaby?'
                    items={HEARD_FROM_OPTIONS}
                    renderFunction={(item: string) => item}
                    valueFunction={(item: string) => item}
                    InputProps={{
                      style: { borderRadius: '8px', color: theme.color.grey.neutral300 },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Box display='flex' justifyContent='flex-end' pt='28px'>
              <TabletButton
                size='medium'
                style={{
                  backgroundColor: theme.color.grey.neutral200,
                  color: '#ffffff',
                  boxSizing: 'border-box',
                  borderRadius: '4px',
                  textTransform: 'none',
                  padding: '7px 12px',
                  fontWeight: 600,
                  fontSize: '13px',
                  marginRight: '8px',
                }}
                onClick={() => prev(values, TrialStepsEnum.YOUR_DETAIL)}
              >
                Back
              </TabletButton>
              <TabletButton
                size='medium'
                variant='text'
                type='submit'
                style={{
                  backgroundColor: theme.color.secondary.main900,
                  color: '#ffffff',
                  boxSizing: 'border-box',
                  borderRadius: '4px',
                  textTransform: 'none',
                  padding: '7px 12px',
                  fontWeight: 600,
                  fontSize: '13px',
                }}
              >
                Next
              </TabletButton>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
